import request from '@/config/axios';

/** 意见反馈分页 */
export const getScenicFeedbackPage = (params: any) => request.get({ url: '/scenic/feedback/page', params });

/** 回复处理意见反馈 */
export const replyScenicFeedback = (id: number, reply: string) => request.put({ url: '/scenic/feedback/reply', params: { id, reply } });

/** 删除意见反馈 */
export const deleteScenicFeedback = (id: number) => request.delete({ url: '/scenic/feedback/delete', params: { id } });
